import { GcxCashPopover } from "..";
import "./index.scss";

export const BrandCashHeader = ({ isApple, cashBack, h2CashBack, name }) => (
  <div className="brand-cash-header">
    <p className="discount">{cashBack}% GCX CASH</p>
    <div className="title-container">
      {h2CashBack ? (
        <span dangerouslySetInnerHTML={{ __html: h2CashBack }} />
      ) : (
        <h2 className="title">GCX Cash Gift Cards</h2>
      )}
      <GcxCashPopover />
    </div>
    <p className="subtitle">
      Get {cashBack}% back in GCX Cash instantly when you buy{" "}
      {isApple ? (
        <>
          an <span className="bold">{name}</span>.
        </>
      ) : (
        <>
          <span className="bold">{name}</span> gift cards at face value.
        </>
      )}
    </p>
  </div>
);
